export const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_arcweaver-hub/artifacts/yzft8wmg_arch%20weaver%20png%20.png";

export const SECTIONS = [
  {
    id: "gaming",
    label: "Gaming",
    eyebrow: "Pillar 01 / Webjaggs",
    headline: "Play. Decide. Survive.",
    description:
      "Interactive games that train you to handle bullying, scams and online threats — built on the Webjaggs Cyber-Safety Decision Engine.",
    cta: "Enter the arcade",
    accent: "#E60000",
    href: "/gaming",
  },
  {
    id: "youtube",
    label: "YouTube Series",
    eyebrow: "Pillar 02 / YouTube Series",
    headline: "YouTube Series.",
    description:
      "Trailers, features and the Bite Force e‑magazine for the cinematic Arkweaver: Guardians of Alkebulan universe.",
    cta: "Watch the trailers",
    accent: "#8B0000",
    href: "/youtube",
  },
  {
    id: "kids",
    label: "Kids Interactive",
    eyebrow: "Pillar 03 / Bite Force",
    headline: "Share your voice.",
    description:
      "Tell your story, take Did‑You‑Know challenges, and learn how to spot online scams, school bullying and digital traps.",
    cta: "Start the session",
    accent: "#F5A623",
    href: "/kids",
  },
];

// YouTube Series videos — embed IDs only (privacy-friendly youtube-nocookie)
export const TRAILERS = [
  { id: "7qseZe05hBU", title: "YouTube Series — Official Trailer 1", kind: "Trailer" },
  { id: "zxWVK70MWos", title: "YouTube Series — Official Trailer 2", kind: "Trailer" },
  { id: "68oLVIooG4o", title: "YouTube Series — Official Trailer 3", kind: "Trailer" },
  { id: "zsmFTfPLKa0", title: "Coming Soon — Promo", kind: "Promo" },
  { id: "GSId3sPp5a4", title: "YouTube Series — Featurette", kind: "Featurette" },
];

export const FACEBOOK_FEATURE = {
  url: "https://www.facebook.com/share/v/1Grie2zc5H/",
  title: "How to Deal with Bullies — Feature (Facebook)",
};

export const EMAGAZINE = {
  url: "https://emagazine.qfinitypublications.online/books/ljhc/",
  title: "Webscouts e‑Magazine — Bite Force",
};

// Educational facts for Kids Interactive
export const DID_YOU_KNOW = [
  {
    category: "Cyberbullying",
    fact:
      "Middle school students facing both school bullying and cyberbullying report substantially higher odds of suicidal behavior. Reporting it early changes outcomes.",
  },
  {
    category: "Online Scams",
    fact:
      'If a stranger online offers a "free" reward in exchange for your password, a photo, or your address — it is always a scam. Real people will never ask for those.',
  },
  {
    category: "School Safety",
    fact:
      "Most school-shooting attackers showed warning signs before acting. Telling a trusted adult about a friend in crisis is not snitching — it is saving a life.",
  },
  {
    category: "Digital Footprint",
    fact:
      "What you post today can be screenshotted forever. Before you send, ask: would I be okay if my grandma, my coach, and my future boss saw this in five years?",
  },
  {
    category: "Sextortion",
    fact:
      "Sextortion criminals pressure kids to send images and then threaten them. The move that breaks them: stop replying, screenshot, and tell a trusted adult instantly.",
  },
  {
    category: "Group Chats",
    fact:
      "If a group chat starts targeting one person, staying silent is a vote in favor of the bully. Leaving the chat or speaking up resets the room.",
  },
];

// True/False mission cards
export const MISSION_CARDS = [
  {
    statement: "If a stranger online sends you a gift card, you should redeem it quickly before it expires.",
    answer: false,
    insight:
      "Strangers do not give free money. Free gift cards online are scams designed to steal your account, your photos or your trust.",
  },
  {
    statement:
      "Telling a trusted adult about a friend who keeps talking about hurting themselves is the right move.",
    answer: true,
    insight:
      "Telling is not snitching — it is protecting. A trusted adult can connect your friend to real help.",
  },
  {
    statement:
      "If someone you only know online asks for a photo of you, sending it once is okay if they promise to keep it private.",
    answer: false,
    insight:
      'Online "promises" can be screenshotted in one second. Never send images to anyone you only know online.',
  },
  {
    statement:
      "Using a strong password and turning on 2-step verification makes your account much harder to hack.",
    answer: true,
    insight:
      "A strong password plus 2-step verification is one of the most powerful upgrades you can make today.",
  },
  {
    statement:
      "If a group chat is laughing at one person, the safest move is to laugh along so they don't target you next.",
    answer: false,
    insight:
      "Silence and laughter give the bully more power. Speaking up — even privately to the target — resets the dynamic.",
  },
];

// Quiz scenarios for Gaming
export const QUIZ_SCENARIOS = [
  {
    scenario:
      "You see your classmate getting roasted in a group chat. The leader of the chat tags you and says 'You agree with us right?'",
    options: [
      { text: "Send a laughing emoji so you don't become the next target.", correct: false },
      {
        text: "Privately DM the target, then screenshot the chat and tell a trusted adult.",
        correct: true,
      },
      { text: "Stay silent. Not your problem.", correct: false },
      { text: "Roast the target harder so the leader respects you.", correct: false },
    ],
    insight:
      "Bystanders break bullying. A private DM to the target plus reporting the screenshots is the single most effective move.",
  },
  {
    scenario:
      "An online friend you've never met in person asks for a 'just one' shirtless photo. They say they'll never share it.",
    options: [
      { text: "Send it once — they promised.", correct: false },
      {
        text: "Stop replying, screenshot the conversation, block, and tell a trusted adult.",
        correct: true,
      },
      { text: "Ask them to send one first to prove trust.", correct: false },
      { text: "Send a face only — no body — so it's safer.", correct: false },
    ],
    insight:
      "This is a sextortion pattern. The image is the leverage. Cut the conversation, save evidence, and tell an adult fast.",
  },
  {
    scenario:
      "A direct message offers you a free Roblox / Fortnite / PlayStation gift card. You only have to 'verify' your account.",
    options: [
      { text: "Click the link — free stuff is free stuff.", correct: false },
      { text: "Enter your password to claim it.", correct: false },
      {
        text: "Delete the message and report it. Free codes from strangers are scams.",
        correct: true,
      },
      { text: "Forward it to your friends so they can claim too.", correct: false },
    ],
    insight:
      'Every "free code — just verify your account" message is a phishing scam. They take your account; you get nothing.',
  },
  {
    scenario:
      "A friend at school keeps saying things like 'nobody would notice if I was gone.' They beg you not to tell anyone.",
    options: [
      { text: "Keep their secret — you promised.", correct: false },
      {
        text: "Tell a trusted adult — counselor, parent, coach — today. This is not snitching.",
        correct: true,
      },
      { text: "Wait a few weeks to see if they get better.", correct: false },
      { text: "Tell other friends but not adults.", correct: false },
    ],
    insight:
      "When a friend's life might be at risk, telling a trusted adult is the bravest, most loyal thing you can do.",
  },
  {
    scenario:
      "Someone you don't know in real life sends a friend request and immediately starts being super flattering and asks where you go to school.",
    options: [
      {
        text: "Decline, block, and report. Real friends don't fish for your school name.",
        correct: true,
      },
      { text: "Tell them — they seem cool.", correct: false },
      { text: "Accept but only share your school in DMs.", correct: false },
      { text: "Make them prove they go to your school first.", correct: false },
    ],
    insight:
      "Predators flatter quickly and fish for location, school name and routine. Decline, block, report.",
  },
];

// Memory match pairs — anti-bullying values
export const MEMORY_PAIRS = [
  { id: "kindness", label: "Kindness", emoji: "K" },
  { id: "courage", label: "Courage", emoji: "C" },
  { id: "report", label: "Report it", emoji: "R" },
  { id: "empathy", label: "Empathy", emoji: "E" },
  { id: "voice", label: "Use your voice", emoji: "V" },
  { id: "trust", label: "Trusted adult", emoji: "T" },
];

// Drag-and-drop story builder — order the steps to defuse an online threat
export const STORY_STEPS = [
  { id: "1", text: "Stop replying — silence cuts their power." },
  { id: "2", text: "Screenshot the messages — save the evidence." },
  { id: "3", text: "Block and report the account on the platform." },
  { id: "4", text: "Tell a trusted adult — parent, teacher, counselor." },
  { id: "5", text: "Check in on yourself — you did the right thing." },
];
